"use strict";

exports.__esModule = true;
exports.getObjectValueByKey = getObjectValueByKey;
exports.isCSR = isCSR;
function getObjectValueByKey(object, value) {
  return Object.keys(object).find(function (key) {
    return object[key] === value;
  });
}
function isCSR() {
  return typeof window !== 'undefined';
}